import { graphql } from '~publish/graphql'

import { CollaborationNoteReactionsFields } from './CollaborationNoteReactionsFields'

export const CollaborationNoteFields = graphql(
  /* GraphQL */ `
    fragment CollaborationNoteFields on CollaborationNote @_unmask {
      id
      text
      authorId
      createdAt
      updatedAt
      author {
        id
        name
        email
        avatar
      }
      annotations {
        content
        indices
        text
        type
        url
        displayValue
        serviceEntityId
      }
      ...CollaborationNoteReactionsFields
    }
  `,
  [CollaborationNoteReactionsFields],
)
